import axios, { AxiosRequestConfig } from 'axios'
import _ from 'lodash'
import { TokenService } from './auth/token.service'
import { UserAuthService } from './auth/auth_user.service'
import { Dictionary } from 'vue-router/types/router'
import {store} from "@/modules/store/store-module";

const ApiService = {
  /**
     * Base class for using API to comunicate with other services,
     * @param baseURL
     */

  // Stores the 401 interceptor position so that it can be later ejected when needed
  _401interceptor: null,

  init (baseURL: string) {
    axios.defaults.baseURL = baseURL
  },

  setHeaders (headers?: Dictionary<string>) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${TokenService.getToken()}`;

    for (const key in headers) {
      axios.defaults.headers.common[key] = headers[key]
    }
  },

  removeHeader () {
    axios.defaults.headers.common = {}
  },

  _parseQueryParams (query_params?: Dictionary<string> | null): string | null {
    // TODO IMPROVEMENT substitude by https://github.com/sindresorhus/query-string
    if (query_params) {
      let query_params_list: Array<string> = _.map(query_params, (value, key) => { return `${key}=${value}` })
      let params: string = '?' + _.join(query_params_list, '&')
      return params
    }
    return ''
  },

  get (resource: string, query_params?: Dictionary<any> | null) {
    return axios.get(`${resource}${this._parseQueryParams(query_params)}`)
  },

  post (resource: string, data: JSON, query_params?: Dictionary<any> | null) {
    return axios.post(`${resource}${this._parseQueryParams(query_params)}`, data)
  },

  put (resource: string, data: JSON, query_params?: Dictionary<any> | null) {
    return axios.put(`${resource}${this._parseQueryParams(query_params)}`, data)
  },

  patch (resource: string, data: JSON, query_params?: Dictionary<any> | null) {
    return axios.patch(`${resource}${this._parseQueryParams(query_params)}`, data)
  },

  delete (resource: string, data: JSON, query_params?: Dictionary<any> | null) {
    return axios.delete(`${resource}${this._parseQueryParams(query_params)}`)
  },

  customRequest (data: Dictionary<any>) {
    try {
      return axios(data)
    } catch (error) {
      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        console.log(error.response.data)
      } else if (error.request) {
        // The request was made but no response was received
        // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
        // http.ClientRequest in node.js
        console.log(error.request)
      } else {
        // Something happened in setting up the request that triggered an Error
        console.log('Error', error.message)
      }
    }
  },

  mount401Interceptor () {
    this._401interceptor = axios.interceptors.response.use(
      (response) => {
        return response
      },
      async (error) => {



        if (error.request.status == 401 || error.request.status == 500 || error.request.status == 400) {
          if (error.config.url.includes('/auth/token/')) {
            // Refresh token has failed. Logout the user
            await store.dispatch('auth/logout');
            //UserAuthService.logout(true);

            throw error
          } else {
            // Refresh the access token
            try {
              await store.dispatch('auth/refreshToken'); //TODO once Vuex auth store is working
              //await UserAuthService.refreshToken();

              // Retry the original request
              return this.customRequest({
                method: error.config.method,
                url: error.config.url,
                data: error.config.data
              })
            } catch (e) {
              // Refresh has failed - reject the original request
              throw error
            }
          }
        }
        // If error was not 401 just reject as is
        throw error
      }
    )
  },
  unmount401Interceptor () {
    // Eject the interceptor
    axios.interceptors.response.eject(this._401interceptor)
  }
};

export { ApiService }
